import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// API Services
import { AuthService } from './api/auth.service';
import { NetworkMemberService } from './api/network-member.service';

@NgModule({
  imports: [CommonModule],
  providers: [AuthService, NetworkMemberService],
})
export class PortalCoreModule {}
